import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from '@mui/material'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'

const StyledSwitch = withStyles({
  root: {
    width: 113,
    height: 20,
    padding: 0,
  },
  rootNoText: {
    width: 60,
  },
  switchBase: {
    padding: 0,
    top: 2,
    left: 3,
    '&$checked': {
      transform: 'translateX(48px)',
      '& + $track': {
        backgroundColor: '#EDF1FB',
        opacity: 1,
        border: 'none',
        '&::after': {
          content: '"Visual"',
          position: 'absolute',
          top: 3,
          left: 12,
          fontSize: 12,
          color: '#2833C5',
        },
      },
    },
    '& input': {
      left: -56,
      width: 169,
      height: 20,
      top: -3,
    },
  },

  switchBaseNoText: {
    '&$checked': {
      transform: 'translateX(28px)',
    },
  },

  thumbChecked: {
    color: COLORS.palette.white,
    width: 60,
    height: 16,
    borderRadius: 30,
    backgroundColor: '#2933C5',
    '&::after': {
      content: '"Visual"',
      position: 'absolute',
      top: 1,
      left: 12,
      fontSize: 12,
      color: COLORS.palette.white,
    },
  },
  thumbUnchecked: {
    color: COLORS.palette.white,
    width: 60,
    height: 16,
    borderRadius: 30,
    backgroundColor: '#2933C5',
    '&::after': {
      content: '"HTML"',
      position: 'absolute',
      top: 1,
      left: 13,
      fontSize: 12,
      color: COLORS.palette.white,
    },
  },
  track: {
    borderRadius: 30,
    backgroundColor: '#EDF1FB',
    opacity: 1,
    '&::after': {
      content: '"HTML"',
      position: 'absolute',
      fontSize: 12,
      top: 3,
      left: 70,
      color: '#2933C5',
    },
  },
  disabled: {
    '&$checked + $track': {
      backgroundColor: COLORS.gray.disableGray2,
    },
  },
  checked: {},
  trackNoText: {
    '&::before, &::after': {
      display: 'none',
    },
  },
})(({ classes, noText, checked, ...props }) => (
  <Switch
    disableRipple
    classes={{
      root: clsx(classes.root, {
        [classes.rootNoText]: noText,
      }),
      switchBase: clsx(classes.switchBase, {
        [classes.switchBaseNoText]: noText,
      }),
      thumb: checked ? classes.thumbChecked : classes.thumbUnchecked,
      track: clsx(classes.track, {
        [classes.trackNoText]: noText,
      }),
      checked: classes.checked,
      disabled: classes.disabled,
    }}
    style={{}}
    {...props}
  />
))

const Switcher = ({ checked, onChange, disabled, ...props }) => (
  <StyledSwitch
    checked={checked}
    onChange={onChange} // e not e.target.checked
    disabled={disabled}
    {...props}
  />
)

Switcher.defaultProps = {
  classes: null,
  checked: false,
  onChange: () => {},
  disabled: false,
  noText: false,
}

Switcher.propTypes = {
  classes: PropTypes.shape,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  noText: PropTypes.bool,
}

export default Switcher
